import React, { useEffect } from "react";
import { MdMiscellaneousServices } from "react-icons/md";
import { Link } from "react-router-dom";
import { BsFillArrowUpRightCircleFill } from "react-icons/bs";

import welcomeimage from "../../assets/images/homescreen/welcomeimage.png";
import civil from "../../assets/images/homescreen/civil.jpg";
import interior from "../../assets/images/homescreen/interior.jpg";
import mpez from "../../assets/images/homescreen/mpez.jpg";

import swiper1 from "../../assets/images/swiper1.jpg";
import swiper2 from "../../assets/images/swiper2.jpg"
import swiper3 from "../../assets/images/swiper4.jpeg";
import swiper4 from "../../assets/images/swiper5.jpg";
import img1 from "../../assets/images/pro1.webp";
import img2 from "../../assets/images/pro2.webp";
import img3 from "../../assets/images/pro1.webp";
import img4 from "../../assets/images/interirorshopoutfit.jpg";
import img5 from "../../assets/images/interirorofficeoutfit.jpg";
import img6 from "../../assets/images/interiorvillaoutfit.jpg";
import homebgbanner from "../../assets/images/homebgbanner.jpg";



import image29 from "../../assets/images/compressed/1000135783.png";
import image30 from "../../assets/images/compressed/1000135787.png";
import image39 from "../../assets/images/compressed/1000135823.png";
import image40 from "../../assets/images/compressed/1000135827.png";
import imgcontact from "../../assets/images/compressed/1000135771.png";


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // Correct import path for Swiper modules

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import Moving from "../../components/Movingimg/Moving";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Ourleaders from "../../components/Ourleaders/Ourleaders";
import Countingnumber from "../../components/Counting/Countingnumber";

import Metatag from "../../components/Metatag/Metatag";
import Contacthome from "../../components/contacthome/contacthome";
import Timeline from "../../components/Timeline/Timeline";





const Home = () => {
  useEffect(() => {
    // Scroll to the top when the page loads
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      once: true,

    });
  }, []);

  const serviceData = [
    {
      id: "01",
      title: "Devotion to Quality",
      content: "We take pride in our unwavering commitment to quality, which is the foundation of our operations. Our rigorous quality management processes ensure that every product or service we deliver meets, and often exceeds, industry standards."
    },
    {
      id: "02",
      title: "Expert Workforce",
      content: "With vast industry experience, our team has honed their skills to expertly manage challenges and provide optimal solutions that exceed client expectations."
    },
    {
      id: "03",
      title: "Prompt Project Delivery",
      content: "Our team works tirelessly to ensure that every project is delivered on time without compromising on quality, thanks to efficient project management systems."
    },
    {
      id: "04",
      title: "Innovative Strategies",
      content: "We are committed to fostering innovation and creativity with cost-effective solutions. Our ability to adapt to the ever-changing market landscape ensures exceptional outcomes for our clients."
    }
  ];


  const slidesData = [
    {
      title: " Megavolt Contracting Services",
      subtitle: "Trusted DEWA Approved Contractor in Dubai",
      buttonLink: "/contactus",
      buttonText: "Discover Our Services",
      buttonColor: "bg-orange",
      imageSrc: swiper1,
    },
    {
      title: " Megavolt Contracting Services",
      subtitle: "Trusted DEWA Approved Contractor in Dubai",
      buttonLink: "/contactus",
      buttonText: "Discover Our Services",
      buttonColor: "bg-orange",
      imageSrc: swiper2,
    },
    {
      title: " Megavolt Contracting Services",
      subtitle: "Trusted DEWA Approved Contractor in Dubai",
      buttonLink: "/contactus",
      buttonText: "Discover Our Services",
      buttonColor: "bg-orange",
      imageSrc: swiper4,
    },
    {
      title: " Megavolt Contracting Services",
      subtitle: "Trusted DEWA Approved Contractor in Dubai",
      buttonLink: "/contactus",
      buttonText: "Discover Our Services",
      buttonColor: "bg-orange",
      imageSrc: swiper3,
    },
    // Add more slide objects as needed
  ];

  const mepServiceData = [
    {
      title: "MEP",
      content: "As leading MEP contractors in the UAE, our expert team of engineers and technicians offers a comprehensive range of MEP services. We focus on high-quality workmanship and ensure timely project delivery.",
      link: "/mpez",
      image: mpez,
      alt: "MEP services",
      icon: <BsFillArrowUpRightCircleFill />
    },
    {
      title: "INTERIOR",
      content: "From concept to completion, we design custom interior solutions that meet client needs. Our goal is to exceed expectations and deliver outstanding results.",
      link: "/interior",
      image: interior,
      alt: "interior design",
      icon: <BsFillArrowUpRightCircleFill />
    },
    {
      title: "CIVIL",
      content: "We provide comprehensive civil engineering services, including design, planning, and construction. Our skilled team delivers innovative solutions tailored to the unique requirements of each project.",
      link: "/civil",
      image: civil,
      alt: "civil services",
      icon: <BsFillArrowUpRightCircleFill />
    },

  ];

  return (
    <div className="">
      <Metatag title="Dewa Approvals | Dewa Approved Contractor | Megavolt Technical Service - Dubai" description="Megavolt Team provides dewa approvals in dubai. Get in touch with our Dubai Approvals Team to apply fo r Electricity and water from our Dewa Appproval services" link="" />


      {/* main home banner */}
      <div className="">
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination, Autoplay]}
          loop={true}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          speed={2000}
          className="mySwiper md:h-[85vh]"
        >
          {slidesData.map((slide, index) => (
            <SwiperSlide key={index}>

              <img src={slide.imageSrc} className="w-full object-cover h-[500px] md:h-auto" alt="itemImage" />
              <div className="absolute z-[999] text-white top-1/4 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[50%]">
                <div className="flex flex-col justify-center items-center h-full">
                  <div className="lg:pl-8 p-3">
                    <h1 className="lg:text-4xl text-xl text-center font-bold">{slide.title}</h1>
                    <p className="text-xl text-center mt-4">{slide.subtitle}</p>
                    <div className="my-8 text-center">
                      <Link
                        to={slide.buttonLink}
                        className={`py-3 md:px-10 px-6 rounded-md ${slide.buttonColor} text-white uppercase`}
                      >
                        {slide.buttonText}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* our story */}

      <div className="container mx-auto space-y-6 p-4 md:space-y-16 md:py-16 overflow-hidden" >
        <div className="mb-5 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
          <div className="order-last flex flex-col justify-center p-4 md:order-first md:col-span-1 lg:col-span-2" data-aos="fade-right" data-aos-duration="1000">
            <h1 className="mb-4 text-2xl font-bold uppercase dark:text-[#dddddd] md:text-4xl">
              Overview of Megavolt 
            </h1>
            <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6">
              We specialize in providing comprehensive contracting services, including civil
              and electrical work, with a strong focus on obtaining . Our team  Megavolt of experts
              ensures that every project meets the strict standards and regulations set by the, making your construction and electrical processes seamless and efficient.
              Whether you need civil works for infrastructure projects or electrical
              installations for commercial or residential spaces. At Megavolt, our team of DEWA approval experts ensures that every project complies with the strict standards and regulations set by DEWA, making your construction and electrical processes seamless and efficient.
 Let us handle the approval process while you focus on building your vision!
            </p>
            <div className=" mt-8">
              <Link to="/blog" className="border py-3 px-10 rounded-md bg-orange text-white">Discover More</Link>
            </div>
          </div>
          <div className="group h-[300px]  bg-gradient-to-t from-[#48c6ef] to-[#6f86d6] md:col-span-1 lg:col-span-1" data-aos="fade-left" data-aos-duration="1000">
            <div className="m-0 h-[300px] w-full duration-300 ease-in group-hover:m-0 xl:mb-[-25px] xl:ml-[25px] xl:mr-[-25px] xl:mt-[25px]">
              <img src={welcomeimage} alt="our story" className="h-[300px] w-full duration-300 ease-in" />
            </div>
          </div>

        </div>
      </div>

      {/* our service */}
      <div className="lg:pt-10 lg:pb-20 py-10 px-3 bg-[#e5e7eb]">
        <h1 className=" font-bold text-2xl md:text-3xl my-5 lg:my-4  pb-8 uppercase text-center">Our authorities</h1>
        <div className="container mx-auto">
          <div className="lg:grid-cols-4 grid gap-3 grid-cols-1 sm:grid-cols-2 overflow-hidden">
            {serviceData.map((service, index) => (
              <div
                key={index}
                data-aos="flip-left"
                data-aos-duration="1500"
                data-aos-delay={index * 200}
                className="relative bg-white lg:p-4 p-3 rounded-tr-[50px] rounded-bl-[50px] group-hover:shadow-[4px_6px_10px_-3px_#bfc9d4] group overflow-hidden transition-all duration-300 ease-linear"
              >
                {/* Linear Gradient Hover */}
                <div className="absolute inset-0 bg-none group-hover:bg-gradient-to-r group-hover:from-[#f7b12d] group-hover:to-[#f58b2d] transition-all duration-300 ease-linear z-0"></div>

                {/* Content */}
                <div className="relative z-10">
                  <div className="bg-[#090a0e] text-[#f7b12d] group-hover:text-white flex items-center justify-center w-[80px] h-[80px] mx-auto  rounded-full shadow-[4px_6px_10px_-3px_#bfc9d4] transition-all ease-linear">
                    <p className="font-semibold text-[35px]">{service.id}</p>
                  </div>
                  <p className="text-2xl font-bold my-4 text-center">{service.title}</p>
                  <p className="text-sm md:text-base p-3 sm:p-1 text-[#7a7a7a] group-hover:text-white text-justify leading-6 transition-colors duration-300 ease-linear">
                    {service.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* our contractors */}
      <div className="container mx-auto overflow-hidden " data-aos="fade-up" data-aos-duration='1300' >
        <div className="grid grid-cols-1 md:grid-cols-12 ">
          <div className="col-span-12 md:col-span-6 ">
            <div className="grid grid-cols-2 lg:pt-8 lg:gap-4 gap-4 p-3 justify-center">
              <div className="h-full sm:h-72">
                <img
                  src={image29}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300   "
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={image30}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={imgcontact}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={image40}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <div className="p-3 lg:px-5 space-y-6 flex items-center flex-col justify-center h-full">
              <h1 className=" font-bold text-2xl md:text-3xl my-5 lg:my-4 uppercase text-center">The City’s Most Trusted Contractors</h1>
              <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6 "> We are a leading MEP company in the UAE, known for delivering exceptional technical services. Our reliable, efficient, and budget-friendly solutions make us a preferred service partner across the region. By utilizing prefabrication and modular systems, we ensure high-quality results within short timelines. Megavolt’s team of mechanical engineers and technicians, skilled in MEP and HVAC systems, expertly manage each project phase with precision and care.</p>
              <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6">Megavolt has successfully executed multiple electrical, construction, HVAC, and MEP projects, consistently designing and completing them to meet the highest safety and quality standards. We provide top-tier MEP services, including installations and technical support, across commercial, industrial, and residential sectors in Dubai. Our longstanding relationships with leading MEP companies in the region reflect our proven expertise. Megavolt has also completed complex electrical engineering projects and mechanical installations, showcasing our capabilities on an international level.</p>
            </div>
          </div>
        </div>
        <div className="my-10 p-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 ">

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-orange transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-orange group-hover:text-black" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Best-in Class Materials</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-orange transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-orange group-hover:text-black" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Modern Design</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-orange transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-orange group-hover:text-black" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Advanced Machinery</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-orange transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-orange group-hover:text-black" />
                  <h4 className="ml-3 font-semibold group-hover:text-white">Experienced Team</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      
      {/* MEP Contractors  */}

      {/* <div>
        <div className="relative bg-no-repeat	bg-cover overflow-hidden" style={{ backgroundImage: `url(${homebgbanner})` }}>
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative text-center py-16 lg:py-24 overflow-hidden" data-aos="zoom-in" data-aos-duration="1500">
            <h1 className="text-[30px] lg:text-[40px] text-white mb-5">Your Trusted MEP Contractors in Dubai
            </h1>
            <p className="text-[#ffffffba] px-3 lg:max-w-[70%] mx-auto text-justify sm:text-center"> As one of Dubai's top MEP contractors, Megavolt is committed to turning your vision into reality. Our team provides exceptional MEP solutions that are both cost-effective and of unmatched quality. Through our expertise and careful project assessment, we guarantee optimal outcomes, ensuring that every aspect of your project is executed to the highest standards.</p>
            <div className="my-8 text-center">
              <Link to="/contactus" className="py-3 px-10 rounded-md bg-orange text-white uppercase inline-block">contact us</Link>
            </div>
          </div>
        </div>
      </div> */}
<div className="bg-[black] p-3 sm:p-6">
  <div className="grid grid-cols-1 md:grid-cols-12 md:gap-8 text-center items-center">
    <div className="col-span-12 md:col-span-5 flex justify-center">
      <img
        src={image39}
        alt="image"
        height={200}
        width={200}
        className="w-full h-auto object-cover"
      />
    </div>
    <div className="col-span-12 md:col-span-7">
      <div
        className="relative text-center py-4 overflow-hidden"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <h1 className="text-[30px] lg:text-[40px] text-orange mb-5">
          Your Trusted MEP Contractors in Dubai
        </h1>
        <div className="text-justify text-[#dad1d1] p-2">
          <p className="py-2">
            As one of Dubai's top MEP contractors, Megavolt is committed to
            turning your vision into reality. Our team provides exceptional MEP
            solutions that are both cost-effective and of unmatched quality.
            Through our expertise and careful project assessment, we guarantee
            optimal outcomes, ensuring that every aspect of your project is
            executed to the highest standards.
          </p>
          <p className="py-4">
            At Megavolt, client satisfaction is our priority. We pride
            ourselves on maintaining open communication, ensuring that your
            requirements are understood and implemented seamlessly. Our
            innovative approach to problem-solving and commitment to timely
            project delivery make us a trusted partner in the industry.
          </p>
        </div>
        <div className="my-8 text-center">
          <Link
            to="/contactus"
            className="py-3 px-10 rounded-md bg-orange text-white uppercase inline-block"
          >
            contact us
          </Link>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* mep service page design */}
      <div className="lg:py-12 p-3 pb-8">
        <h1 className="font-bold text-2xl md:text-3xl text-center my-8 uppercase">Our Offerings</h1>
        <div className="container mx-auto overflow-hidden">
          <div className="lg:grid-cols-3 grid gap-5 lg:gap-12 grid-cols-1  sm:grid-cols-2">
            {mepServiceData.map((service, index) => (
              <div key={index}
                data-aos="fade-right"
                data-aos-duration="1500"
                data-aos-delay={index * 200}
                className="relative border lg:p-5 p-3 rounded-lg shadow-[4px_6px_10px_-3px_#bfc9d4] group  hover:bg-black overflow-hidden">

                <div className="h-[280px]">
                  <img src={service.image} alt={service.alt} className="h-full w-full" />
                </div>
                <h1 className="text-lg font-bold my-3 text-center group-hover:text-orange">{service.title}</h1>
                <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6 group-hover:text-white">
                  {service.content}
                </p>

                {/* Overlay and Hover Effect */}
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center flex-col gap-2 justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-orange text-lg font-bold">Click Me</p>
                  <div className="flex items-center justify-center">
                    <Link to={service.link} className="text-white text-3xl">{service.icon}</Link>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* <Countingnumber /> */}
      <Countingnumber />
      {/* Featured works */}
      <div className="border bg-[#e5e7eb]">
        <h1 className="font-bold text-2xl md:text-3xl sm:my-8 my-4 uppercase text-center">Featured Works</h1>
        <div className="sm:mb-20 mb-8">
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 3000, // Delay between slides in milliseconds
              disableOnInteraction: false, // Keep autoplay even when interacted
            }}
            loop={true} // Loop the slides continuously
            speed={1200} // Adjust for smoothness
            modules={[Pagination, Autoplay]}
            className="mySwiper"
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            }}
          >
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img1} alt="img1" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img2} alt="img2" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img3} alt="img3" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img4} alt="img4" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img5} alt="img5" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="w-full h-64">
                <img className="w-full h-full object-cover" src={img6} alt="img6" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>


      {/* our leaders */}
      {/* <Ourleaders /> */}
    
<Timeline/>
      
      {/* Scrolling images */}
      <Moving />
      <Contacthome />

    </div>
  );
};

export default Home;
